module.exports = __webpack_public_path__ + "img/oculus_paper_wireframe.32f60cda.png";